import { ImStudent } from './../../../../shared/services/im-models/im-student.service';
import { TSortDirections } from './../../../../shared/services/list-services/sort-and-filter.service';
import { BehaviorSubject } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { IStateService } from 'angular-ui-router';
import { IRowData } from 'Src/ng2/shared/models/list-models';
import { ObjectCache } from 'Src/ng2/shared/services/object-cache/object-cache.service';

@Injectable()
export class ListNavigationService {
  constructor(
    @Inject('$state') public $state: IStateService,
    public objectCache: ObjectCache,
    private imStudent: ImStudent,
  ) {}

  updateUrl(
    sortKey$: BehaviorSubject<string>,
    sortDirection$: BehaviorSubject<TSortDirections>,
    filterFormControl: FormControl,
    madlibModel?: FormGroup | undefined,
  ): void {
    const sortKey = sortKey$.value;
    const sortDirection = sortDirection$.value;
    const search = filterFormControl.value;

    const paramsWithoutMadlib = { sortKey, sortDirection, search };

    madlibModel
      ? this.$state.go('.', { ...paramsWithoutMadlib, ...this.getMadlibQueryParams(madlibModel) }, { notify: false })
      : this.$state.go('.', paramsWithoutMadlib, { notify: false });
  }

  goToStudentProfile(studentTableRowData: IRowData[]): void {
    const [studentCol] = studentTableRowData;
    const studentMetaData = JSON.parse(studentCol.meta);
    const objectToCache: { [key: string]: [string] } = { studentId: [studentMetaData.data.slice(0, 9)] };
    const schoolId = this.$state.params && this.$state.params.schoolId;
    let isSummerOnly;

    // the way that this function is being used in some context/lists makes it lose the `this` context
    // the check for `this.imStudent` is to avoid calling methods on that service if the `this` context has been lost
    if (schoolId && this.imStudent) {
      const student = { _id: studentMetaData.data };
      isSummerOnly = this.imStudent.isSummerOnly(student, schoolId);

      if (isSummerOnly) {
        // _id is needed for summer only students in the student route `filteredStudents` resolver
        objectToCache._id = [studentMetaData.data];
      }
    }

    const cachedStudent = this.objectCache.cacheObject(objectToCache);
    this.$state.go('main.school.single-student-filter-all', { filter: cachedStudent });
  }

  private getMadlibQueryParams(madlibModel: FormGroup) {
    const { focus, filter, grouping } = madlibModel.value;
    return {
      ...{
        focus: focus.graphQlKey,
        filter: filter.graphQlKey,
        grouping: grouping.graphQlKey,
      },
    };
  }
}
